import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from './state';
import { TField } from '@/common/basis/types/tfield';

const slice = createSlice({
  name: 'bookingMeeting',
  initialState,
  reducers: {
    setIsOpenBookingMeeting: (state, action: PayloadAction<boolean>) => {
      state.isOpenBookingMeeting = action.payload;
    },
    setBookingMeetingType: (state, action: PayloadAction<TField.MeetingType>) => {
      state.bookingMeetingType = action.payload;
    },
    setIsOpenCannelMeeting: (state, action: PayloadAction<boolean>) => {
      state.isOpenCannelMeeting = action.payload;
    },
    setIsOpenBookingDetail: (state, action: PayloadAction<boolean>) => {
      state.isOpenBookingDetail = action.payload;
    },
    setDetailRoomId: (state, action: PayloadAction<string>) => {
      state.detailRoomId = action.payload;
    },
    setBookingRoomId: (state, action: PayloadAction<string>) => {
      state.bookingRoomId = action.payload;
    },
    setCancelRoomId: (state, action: PayloadAction<string>) => {
      state.cancelRoomId = action.payload;
    },
    setIsHandBookingSuccess: (state, action: PayloadAction<boolean>) => {
      state.isHandBookingSuccess = action.payload;
    },
  },
});

export const {
  setIsOpenBookingMeeting,
  setIsOpenCannelMeeting,
  setIsOpenBookingDetail,
  setDetailRoomId,
  setBookingRoomId,
  setCancelRoomId,
  setIsHandBookingSuccess,
  setBookingMeetingType,
} = slice.actions;

export default slice.reducer;
